export default "__VITE_ASSET__efd9d816__"